import type { Types } from '@ohif/core';
import { utils } from '@ohif/core';
import { findSeriesId, getSeriesArchive } from './clients/orthanc';
import { describeError } from './utils';

const { downloadBlob } = utils;

export default function getCommandsModule({
  servicesManager,
}: Types.Extensions.ExtensionParams): Types.Extensions.CommandsModule {
  const actions = {
    downloadSeries: async ({ displaySetInstanceUID }: { displaySetInstanceUID: string }) => {
      const displaySetService = servicesManager.services
        .displaySetService as AppTypes.DisplaySetService;
      const { uiNotificationService } = servicesManager.services;

      const notifyFailure = (message: string) =>
        uiNotificationService?.show({
          title: 'Download series',
          message,
          type: 'error',
          duration: 5000,
        });

      if (typeof displaySetInstanceUID !== 'string') {
        notifyFailure('Could not identify this series.');
        return;
      }
      const displaySet = displaySetService.getDisplaySetByUID(displaySetInstanceUID);

      const { SeriesInstanceUID } = displaySet ?? {};
      if (!SeriesInstanceUID) {
        notifyFailure('Could not identify this series.');
        return;
      }

      let orthancSeriesId: string | null;
      try {
        orthancSeriesId = await findSeriesId(SeriesInstanceUID);
      } catch (error) {
        console.error(
          `[sycai] findSeriesId failed for ${SeriesInstanceUID} ${describeError(error)}`
        );
        orthancSeriesId = null;
      }

      if (!orthancSeriesId) {
        notifyFailure('Could not find this series on the PACS.');
        return;
      }

      let archive: Blob;
      try {
        archive = await getSeriesArchive(orthancSeriesId);
      } catch (error) {
        console.error(
          `[sycai] getSeriesArchive failed for ${orthancSeriesId} ${describeError(error)}`
        );
        notifyFailure('Could not download this series.');
        return;
      }

      downloadBlob(archive, { filename: `${SeriesInstanceUID}.zip` });
    },
  };

  const definitions = {
    downloadSeries: actions.downloadSeries,
  };

  return {
    actions,
    definitions,
    defaultContext: 'DEFAULT',
  };
}
